import {
  cloneDeep
} from "lodash";

import {
  getUniteGoodsList
} from '@/api/memberNew/activeGoods'
let unionGoodsList = []
/** 获取联运商品的数据 */
export const getUniteGoods = async () => {
  const {
    data
  } = await getUniteGoodsList();
  console.log('审核获取联运商品的数据', data);
  unionGoodsList = data.data
};
getUniteGoods()

/** 根据联运商品id返回商品信息 */
export const getUnionGoodsName = (id) => {
  const item = unionGoodsList.find(item => item.id == id);
  return item ? item.salePrice + '元' : '';
};

/** 定价周期的枚举 */
export const getSalePeriodUnit = (salePeriod) => {
  /** 定价周期单位：1日 2月 3季 4年 */
  switch (salePeriod) {
    case 1:
      return "日";
    case 2:
      return "月";
    case 3:
      return "季";
    case 4:
      return "年";
    default:
      return "-";
  }
}

/** 前端可见的枚举 */
export const getFrontVisible = (frontVisible) => {
  /** 前端可见：1可见 2不可见 */
  switch (frontVisible) {
    case 1:
      return "是";
    case 2:
      return "否";
    default:
      return "-";
  }
}

/** 激活码商品前端可见的枚举 */
/** 前端是否可见：0-否，1-是 */
export const getFrontVisibleGoods = (frontVisible) => {
  switch (frontVisible) {
    case 0:
      return "否";
    case 1:
      return "是";
    default:
      return "-";
  }
}

/** 状态的枚举 */
export const getStatus = (status) => {
  switch (status) {
    case 1:
      return "生效";
    case 0:
      return "失效";

    default:
      return "-";
  }
}

/** 提交审核显示转化 */
export const submitAuditTrans = (data) => {
  return {
    1: {
      name: '激活码名称:',
      value: data.name || '-',
    },
    2: {
      name: '激活码会员:',
      value: data.memberTypeName || '-',
    },
    3: {
      name: '定价周期:',
      value: data.salePeriodDescr || '-',
    },
    4: {
      name: '售价:',
      value: (data.salePrice ? data.salePrice + '元' : '-'),
    },
    5: {
      name: '联运商品:',
      value: data.unionGoodsId === 0 ? '无' : data.unionGoodsName
    },
    6: {
      name: ' ',
      value: data.unionGoodsDescr + ' ' + getUnionGoodsName(data.unionGoodsId) || '-',
    },
    7: {
      name: '前端可见:',
      value: (getFrontVisibleGoods(data.frontVisible)),
    },
    8: {
      name: '状态:',
      value: (getStatus(data.status)),
    },
    9: {
      name: '备注:',
      value: data.descr,
    }
  };
};


//^ ^--------------激活码生成-------------^ ^
/** 新增数据转化 */
export const addTrans = (data) => {
  const params = cloneDeep(data);
  if (data.id) {
    params.id = data.id;
  }
  /** 根据生成类型调整参数 */
  /** 立即生成 */
  if (params.generateType === 1) {
    /** 生成数量 */
    params.generateNum = Number(params.generateNum);
    /** 过期类型 */
    params.expireType = Number(params.generateType);
  } else if (params.generateType === 2) {
    /** 实时生成 */
    params.validDays = Number(params.validDays)
    /** 过期类型 */
    params.expireType = Number(params.generateType);
  }

  return params
};

/** 编辑数据转化 */
export const editTrans = (data) => {
  const params = {};
  if (data.id) {
    params.id = data.id;
  }
  params.descr = data.descr;
  params.img = data.img;

  return params
};
